import Menu from './components/Menu';


export const routes = [
	{
		path: '/menu',
		exact: true,
		component: Menu,
		name: 'Menu',
	}
];